var map = {
	"./BOTAO.png": "e911",
	"./CHANGLIAN.png": "01bf",
	"./CHANGLIAN_BLUE.png": "1faf",
	"./CHANGLIAN_LONT.png": "7df9",
	"./CYTS.png": "f517",
	"./DOSSEN.png": "7907",
	"./ELONG.png": "3c6e",
	"./GREEN_TREE.png": "c8b7",
	"./HOME_INNS.png": "6354",
	"./HOTELBEDS.png": "e667",
	"./HUAZHU.png": "d13a",
	"./HUAZHU_NEW.png": "f1e4",
	"./JINJIANG.png": "24c6",
	"./LONGTENG.png": "e32c",
	"./MEITUAN.png": "9bc9",
	"./QUNAR.png": "1d3f",
	"./SELF.png": "a321",
	"./SUPER8.png": "9683",
	"./TITAN.png": "78f8",
	"./VIENNA.png": "0690",
	"./WEHOTEL.png": "33aa",
	"./YADUO.png": "d447"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b9c2";